export default __webpack_public_path__ + "static/media/45-min.cb8e7b98.png";